import { Injectable, Inject } from '@angular/core';
import { DOCUMENT} from '@angular/common';

@Injectable()
export class AuxiliarService {
    private dom:Document;

  constructor(@Inject( DOCUMENT ) dom: Document) {
      this.dom=dom;
  }

/*funciones utiles entre update var assoc, tabla, y reactForm
    ejemplo Pricing modal- cuando se actualizaba el price_data(object) si no se refrescava la pagina, el valor devuelto era un objeto/json string, y en el modal
    el componente vars assoc partia los valores por letras*/
    isObj(element){
        if(typeof element != 'object'){
            if(element.includes('{')){
                return true;
            }else{
                return false;
            }
        }
        return true;
    }

    checkAsObj(element){
        if(typeof element != 'object'){
            if(element.includes('{')){
                return JSON.parse(element);
            }
        }
        return element;
    }

    /*---------------------------*/

    copyToClip(value:string) {
        let textarea = this.dom.createElement("textarea");
        textarea.style.height = "0px";
        textarea.style.left = "-100px";
        textarea.style.opacity = "0";
        textarea.style.position = "fixed";
        textarea.style.top = "-100px";
        textarea.style.width = "0px";
        this.dom.body.appendChild(textarea);
        textarea.value = value;
        textarea.select();
        this.dom.execCommand("copy");
    }


    getDelimiters(){
        return [
            {value: ";", label: 'Dot and comma' + ' ( ; )' },
            {value: ",", label: 'Comma' + ' ( , )' },
            {value: "TAB", label: 'Tab' + ' ( )' },
            {value: "|", label:'Pipe' + ' ( | )' },
            {value: "~|~", label: 'Special type'+ ' ( ~|~ )' }
        ];
    }

    getEnclosures(){
        return [
            {value: "DOUBLE_QUOTE", label: 'Double Quote '+ '( \" )'},
            {value: "SIMPLE_QUOTE", label: 'Single Quote '+'( \' ) ' },
            {value: "EMPTY", label: 'Empty'}
        ];
    }

}





// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/services/auxiliar.service.ts